import audience from "../../../images/icon/audience.svg";
import contextual from "../../../images/icon/contextual.svg";
import opt from "../../../images/icon/opt.svg";
import { Card } from "../card";
const advantages = [
  {
    icon: audience,
    title: "1:1 NPI-Level Targeting",
    text: `Target by license, specialty, procedure/billing codes, and location.`,
  },
  {
    icon: opt,
    title: "Engagement Reporting",
    text: `Monthly lists showing which HCPs viewed and clicked—no form fills required.`,
  },
  {
    icon: contextual,
    title: "Cross-Channel Reach",
    text: `Ads run across display, video, LinkedIn, mobile, and even conference geofencing.`,
  },
];

export const RecruitmentAdvantages = () => {
  return (
    <section className="section-sp2">
      <h1 className="text-center">What sets our campaigns apart</h1>
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
          margin: "0,auto",
          gap: "30px",
          justifySelf: "center",
        }}
        className="advantages"
      >
        {advantages.map((advantage) => (
          <Card
            icon={advantage.icon}
            title={advantage.title}
            text={advantage.text}
            minHeight="275px"
            alignItems="center"
            textAlign="center"
          />
        ))}
      </div>
    </section>
  );
};
